var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hp-hero',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.$route.meta.title)))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }